'use strict';

import React, { Component } from 'react'

import _ from 'lodash'

import { DateTime } from 'luxon'

import Layout from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import OrderInfos from '@/OrderInfos'

import DatePicker from '@/Form/V2/DatePicker'

import FormElement from '@/Form/toolkit/FormElement'

import SearchBar from '@Pure/SearchBar'
import Loader    from '@Pure/Loader'

import { search } from '@root/utility'

const { app, qwest, moment } = window;

export default class OrdersInfosListPage extends Component
{
	state =
	{
		orders: [],

		shippings: [],

		searched:
		{
			value: ''
		},

		filter_status: [],

		form_data: { },

		status_messages: { },

		start: moment()
		.subtract(15, 'days')
		.startOf('month')
		.format('YYYY-MM-DD'),

		end: moment().format('YYYY-MM-DD'),

		delayed_start: moment()
		.subtract(15, 'days')
		.startOf('month')
		.format('YYYY-MM-DD'),

		delayed_end: moment().format('YYYY-MM-DD'),

		status:
		{
			new: true,
			processing: true,
			completed: true,
			canceled: true
		},

		loading: true
	};

	UNSAFE_componentWillMount ()
	{
		var component = this, props = this.props;

		app.resetFunctions();
	}

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		component.fetchOrders({ });
	}

	fetchOrders = ({ start, end, status={ } }) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState({ loading: true });

		const start_date = start !== undefined
		? start
		: state.delayed_start;

		const end_date = end !== undefined
		? end
		: state.delayed_end;

		const selected_status = Object.keys(state.status)
		.reduce(function (list, name)
		{
			const selected = status[name] !== undefined
			? [true, 'true'].includes(status[name])
			: [true, 'true'].includes(state.status[name]);

			return selected ? list.concat([name]) : list;
		},
		[]);

	// get all orders
		qwest.post('/order/get-account-orders',
		{
			start: start_date,
			end: end_date,

			status: selected_status
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				orders: response.orders,
				shippings: response.shippings,
				loading: false
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	handleStatusChange = (e, data) =>
	{
		const component = this, props = this.props, state = this.state;

	// Checkbox did mount
		if (e === null) return;

		let name = data.name;

		state.status[name] = [true, 'true'].includes(e.target.checked);

		component.setState(
		{
			status: state.status
		});

		component.fetchOrders({ status: state.status });
	}

	handleSearch = (value, search) =>
	{
		const component = this, props = this.props;

		component.setState(
		{
			searched:
			{
				value: value,
				data: (search ? search.data : undefined)
			}
		});

		app.emit('searchChange');
	}

	handleDateChange = ({ e, name, value }) =>
	{
		const component = this, props = this.props, state = this.state;

		if (!e) return;

		if (component.date_timeout)
		{
			window.clearTimeout(component.date_timeout);
		}

		const is__invalid = value && !DateTime.fromISO(value).isValid;

		const update =
		{
			[name]: value || ''
		};

		const new_date = !is__invalid
		? value || ''
		: '';

		component.setState(update);

		if (is__invalid) return;

		component.date_timeout = window.setTimeout(function ()
		{
			component.setState(
			{
				['delayed_' + name]: new_date
			});

			component.fetchOrders({ [name]: new_date });
		},
		400);
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const is__EC_admin = app.state.session.permissions.title === 'EC';

		const searched = state.searched.value;

		let days = [], filtered_orders = state.orders;

		if (searched.length > 1 && !state.loading)
		{
			filtered_orders = state.orders.filter(function (order)
			{
				if (searched.length <= 1)
				{
					return true;
				}

				let matches = 0;

				matches += search(order.number, searched);
				matches += search(order.user.firstname + ' ' + order.user.lastname, searched);

				if (order.user.permissions.title === 'EC')
				{
					order.products.forEach(function (product)
					{
						if (product.EC_order_as)
						{
							matches += search(product.EC_order_as, searched);
						}
					});
				}

				return matches > 0;
			});
		}

		const orders = state.loading ?
		(
			<div className="orders__loader_container">
				<Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />
			</div>
		)
		: filtered_orders.map(function (order)
		{
			let day = window.moment(order.createdAt).startOf('day').format();
			let show_date = false;

			if (days.includes(day) === false)
			{
				days.push(day);

				show_date = true;
			}

			let shippings = state.shippings
			.filter(function (shipping)
			{
				let has_order = shipping.products.concat(shipping.items)
				.find(data => data.order_id === order.id);

				return typeof has_order !== 'undefined';
			});

			let output =
			(
				<OrderInfos key={ order.id } data={ order } shippings={ shippings }
					artists={ state.artists } show_date={ show_date }
					EC-admin={ is__EC_admin }
				/>
			);

			return output;
		});

		let header =
		(
			<div className="c-order-infos--header">

				<div className="c-order-infos__order">

					<div className="c-order-infos__number">Commande N°</div>

					{
						is__EC_admin
						? <div className="c-order-infos__bill">Facture N°</div>
						: undefined
					}

					<div className="c-order-infos__total-price">Prix total</div>

					<div className="c-order-infos__text">Informations</div>

					<div className="c-order-infos__payment">Paiement</div>

					<div className="c-order-infos__status">État</div>

					<div className="c-order-infos__collapse-indicator" />

				</div>

			</div>
		);

		const title = is__EC_admin
		? 'Liste des commandes'
		: 'Mes commandes';

		var output =
		(
			<Layout history={ props.history } page_title={ title }>

				<div className="page-content">

					<HolidaysMessage />

					<div className="o-grid-3 u-margin-bottom-20
						order-management-filters">

						<div className="o-grid__item u-flex u-items-center">
							<SearchBar hide_btn={ true } placeholder="N° de commande"
								handleChange={ component.handleSearch }
								value={ state.searched.value }
							/>
						</div>

						<div className="o-grid__item u-flex u-items-center">

							<FormElement name="new"
								type="checkbox" data={ state.status }
								onChange={ component.handleStatusChange }
								status={ state.status_messages }
								label="En attente"
							/>

							<FormElement name="processing"
								type="checkbox" data={ state.status }
								onChange={ component.handleStatusChange }
								status={ state.status_messages }
								label="En traitement" />

							<FormElement name="completed"
								type="checkbox" data={ state.status }
								onChange={ component.handleStatusChange }
								status={ state.status_messages }
								label="Terminée"
							/>

							<FormElement name="canceled"
								type="checkbox" data={ state.status }
								onChange={ component.handleStatusChange }
								status={ state.status_messages }
								label="Annulée"
							/>

						</div>

						<div className="o-grid__item u-flex u-items-center u-gap-20">

							<DatePicker name="start" label="Du"
								onChange={ component.handleDateChange }
								value={ state.start }
								inline
							/>

							<DatePicker name="end" label="Au"
								onChange={ component.handleDateChange }
								value={ state.end }
								bemit={ ['align-right'] }
								inline
							/>

						</div>

					</div>

					{ header }

					{ orders }

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}